import axios from 'axios';

import fieldActions from 'core/fields/actions';
import groupActions from 'core/groups/actions';
import pageActions from 'core/page/actions';
import plaidActions from 'core/plaid/actions';
import workFlowActions from 'core/workflow/actions';
import homeActions from 'core/home/actions';
import sessionActions from './actions';

export default (state = {}, action) => {
  switch (action.type) {
    case homeActions.START_SUCCESS:
    case workFlowActions.START_SUCCESS:
    case sessionActions.GET_SUCCESS: {
      axios.defaults.headers.common['X-CSRF'] = action.payload.data.meta.tokens.csrf;
      const updatedState = {
        ...state,
        data: {
          ...state.data,
          ...action.payload.data?.data,
        },
        meta: {
          ...state.meta,
          ...action.payload.data?.meta,
          configs: {
            ...state.meta.configs,
            ...action.payload.data.meta?.configs,
            locale: action.payload.data.meta?.configs?.locale ?? state.meta.configs.locale,
          },
        },
      };

      return {
        ...updatedState,
      };
    }
    case fieldActions.RERENDER_FAILED:
    case fieldActions.RERENDER_SUCCESS:
    case fieldActions.FETCH_AUTOCOMPLETE_SUCCESS:
    case fieldActions.VALIDATE_SUCCESS:
    case pageActions.NEXT_FAILED:
    case pageActions.NEXT_SUCCESS:
    case pageActions.GO_SUCCESS:
    case pageActions.GO_FAILED:
    case pageActions.ACCEPT_ADDRESS_SUCCESS:
    case pageActions.ACCEPT_ADDRESS_FAILED:
    case pageActions.RESEND_VERIFICATION_CODE_SUCCESS:
    case pageActions.RESEND_VERIFICATION_CODE_FAILED:
    case pageActions.MOBILE_VALIDATION_RESEND_SUCCESS:
    case pageActions.MOBILE_VALIDATION_RESEND_FAILED:
    case pageActions.MOBILE_VALIDATION_SUBMIT_SUCCESS:
    case pageActions.MOBILE_VALIDATION_SUBMIT_FAILED:
    case pageActions.START_SUCCESS:
    case pageActions.STATUS_SUCCESS:
    case pageActions.BACK_SUCCESS:
    case pageActions.SAVE_SIGNATURE_SUCCESS:
    case pageActions.SAVE_SIGNATURE_FAILED:
    case pageActions.CONTINUE_USER_SUCCESS:
    case pageActions.CONTINUE_JOINT_SUCCESS:
    case pageActions.VERIFY_FUNDING_SUCCESS:
    case pageActions.VERIFY_FUNDING_FAILED:
    case plaidActions.FETCH_ACCOUNTS_SUCCESS:
    case plaidActions.FETCH_ACCOUNTS_FAILED:
    case plaidActions.HANDLE_VERIFICATION_QUESTIONS:
    case plaidActions.UPDATE_META_DONE:
    case plaidActions.LINK_VERIFICATION_SUCCESS:
    case plaidActions.LINK_VERIFICATION_FAILED:
    case groupActions.UPLOAD_FAILED:
    case groupActions.UPLOAD_SUCCESS:
    case groupActions.NEXT_FAILED:
    case groupActions.NEXT_SUCCESS:
    case groupActions.UPDATE_SUCCESS:
    case workFlowActions.RESTART_SUCCESS:
    case workFlowActions.RESTART_FAILED:
    case workFlowActions.HOME_FAILED:
    case workFlowActions.START_FAILED: {
      if (action.payload && action.payload.data) {
        const { data: resp } = action.payload;
        if (resp && resp.meta && resp.meta.tokens && resp.meta.tokens.csrf && state.meta) {
          axios.defaults.headers.common['X-CSRF'] = resp.meta.tokens.csrf;
          return {
            ...state,
            meta: {
              ...state.meta,
              tokens: resp.meta.tokens,
            },
          };
        }
      }
      return state;
    }
    default:
      return state;
  }
};
